/**
 * "hace 5 min" / "5 minutes ago", in the UI language, via Intl.RelativeTimeFormat.
 */
import type { Locale } from './translations.ts'

const UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ['year', 365 * 24 * 3600_000],
  ['month', 30 * 24 * 3600_000],
  ['week', 7 * 24 * 3600_000],
  ['day', 24 * 3600_000],
  ['hour', 3600_000],
  ['minute', 60_000],
]

export function formatRelative(timestampMs: number, locale: Locale, now: number = Date.now()): string {
  const diff = timestampMs - now
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  for (const [unit, ms] of UNITS) {
    if (Math.abs(diff) >= ms) return rtf.format(Math.round(diff / ms), unit)
  }
  return rtf.format(0, 'minute')
}
